<div class="auth">
    <div class="auth_left">
        <div class="card">
            <div class="text-center mb-5">
                <a class="header-brand" [routerLink]="['/hr-dashboard']" href="javascript:void(0)"><i
                        class="fe fe-command brand-logo"></i></a>
            </div>
            <div class="card-body">
                <div class="card-title">Forgot password</div>
                <p class="text-muted">Enter your email address and your password will be reset and emailed to you.</p>
                <div class="form-group">
                    <label class="form-label" for="exampleInputEmail1">Email address</label>
                    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                        placeholder="Enter email">
                </div>
                <div class="form-footer">
                    <button type="submit" class="btn btn-primary btn-block">Send me new password</button>
                </div>
            </div>
            <div class="text-center text-muted">
                Forget it, <a [routerLink]="['/login']" href="javascript:void(0)">Send me Back</a> to the Sign in
                screen.
            </div>
        </div>
    </div>
    <div class="auth_right">
        <carousel [isAnimated]="true">
            <slide>
                <img src="assets/images/slider1.svg" class="img-fluid" alt="first slide">
                <div class="px-4 mt-4">
                    <h4>Fully Responsive</h4>
                </div>
            </slide>
            <slide>
                <img src="assets/images/slider2.svg" class="img-fluid" alt="second slide">
                <div class="px-4 mt-4">
                    <h4>Quality Code and Easy Customizability</h4>
                </div>
            </slide>
            <slide>
                <img src="assets/images/slider3.svg" class="img-fluid" alt="third slide">
                <div class="px-4 mt-4">
                    <h4>Cross Browser Compatibility</h4>
                </div>
            </slide>
        </carousel>
    </div>
</div>